import { UserService } from '../../../../services/userService';
import { createColumnHelper } from '@tanstack/react-table';

export const fetchData = async ({ pageIndex = 0, pageSize = 10, username, setLoader, userSelectHandler }) => {
  if (pageIndex == undefined && pageSize == undefined) return;

  setLoader && setLoader(true);
  try {
    let retData;

    if (username && username.length > 0) {
      retData = await UserService.getAllUsers(0, pageSize, username);
    } else {
      retData = await UserService.getAllUsers(pageIndex, pageSize);
    }

    setLoader && setLoader(false);
    return {
      rows: prepareUsersData(retData, userSelectHandler),
      pageCount: retData.data.pageCount,
    };
  } catch (e) {
    setLoader && setLoader(false);
  }
};

export const prepareUsersData = (usersData, userSelectHandler) => {
  const data = usersData && usersData.data && usersData.data.users;
  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor((row) => row.username, {
      id: 'username',
      cell: (info) => (
        <a onClick={() => (userSelectHandler ? userSelectHandler(_.get(info, 'row.original')) : null)}>
          {info.getValue()}
        </a>
      ),
      header: () => <span>User Name</span>,
    }),
    columnHelper.accessor('firstName', {
      id: 'firstName',
      cell: (info) => (
        <div
          className="truncate"
          style={{ maxWidth: 220 }}
          data-tooltip-id="my-tooltip1"
          data-tooltip-content=""
        >
          {info.getValue()}
        </div>
      ),
      header: () => <span>First Name</span>,
    }),
    ,

    columnHelper.accessor('lastName', {
      header: () => 'Last Name',
      cell: (info) => info.renderValue(),
    }),
    columnHelper.accessor('emailId', {
      header: () => 'Email ID',
      cell: (info) => info.renderValue(),
    }),
    columnHelper.accessor('phoneNumber', {
      header: () => 'Phone Number',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('roles', {
      header: () => 'Roles',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue().join(',')}
        </div>
      ),
    }),
    columnHelper.accessor('userStatus', {
      header: () => 'User Status',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
    }),
  ];
  return { columns, data };
};
